import { createRoute, redirect } from "@tanstack/react-router"

import { ProjectSettingsDialogOpener } from "@/components/ProjectSettingsDialog/ProjectSettingsDialogOpener.tsx"
import { isTabId } from "@/components/ProjectSettingsDialog/ProjectSettingsTabId.ts"
import { withGlobalLoader } from "@/lib/context.ts"
import { NEW_PROJECT_KEY } from "@/lib/displayUtils.ts"
import { normalizeProjectKey } from "@/lib/std.ts"
import { initTaskLocation, Navigator } from "@/routes/Navigator.ts"
import { NewProjectScene } from "@/routes/projects/NewProjectScene.tsx"
import { OrgRoute } from "@/routes/root/RootRoute.tsx"

import type { ProjectSettingsTabId } from "@/components/ProjectSettingsDialog/ProjectSettingsTabId.ts"


export const ProjectsRoute = createRoute({
  path: "p",

  getParentRoute: () => OrgRoute,
})


export const ProjectsIndexRoute = createRoute({
  path: "/",
  beforeLoad: ({ params }) => {
    throw redirect(Navigator.orgHome(params.orgId))
  },

  getParentRoute: () => ProjectsRoute
})


export const NewProjectRoute = createRoute({
  path: "new",
  component: () => <NewProjectScene />,

  getParentRoute: () => ProjectsRoute,
})

export const ProjectRootRoute = createRoute({
  path: "$projectKey",

  beforeLoad: async ({ context, params }) => {
    const project = await withGlobalLoader(context, context.queries.getProjectV2({ key: params.projectKey }))
    return { project }
  },

  loader: ({ context }) => {
    return { project: context.project }
  },

  getParentRoute: () => ProjectsRoute,
})

export const ProjectHomeRoute = createRoute({
  path: "/",
  beforeLoad: ({ context }) => {
    if (context.project.initProjectTaskId) {
      throw redirect(initTaskLocation(context.orgId, context.project.key, context.project.initProjectTaskId))
    }

    if (normalizeProjectKey(context.project.key) == NEW_PROJECT_KEY) {
      throw redirect(Navigator.newProject(context.orgId, {
        closeLocation: Navigator.orgHome(context.orgId)
      }))
    }

    throw redirect(Navigator.project(context.orgId, context.project.key))
  },

  getParentRoute: () => ProjectRootRoute,
})

export const ProjectSettingsRoute = createRoute({
  path: "settings/$tab",
  component: () => <ProjectSettingsDialogOpener />,

  beforeLoad: ({ params }) => {
    if (!isTabId(params.tab)) {
      throw new Error(`Invalid settings tab: ${params.tab}`)
    }
  },

  loader: ({ params }) => {
    return {
      tab: params.tab as ProjectSettingsTabId,
    }
  },

  getParentRoute: () => ProjectRootRoute
})